module.exports = __webpack_public_path__ + "static/media/icon_calculated.885f5473.svg";